import api from "./api";

const testSampleTypeService = {
  getAll: (filters = {}) => api.get("/test-sample-types", { params: filters }),

  getById: (id) => api.get(`/test-sample-types/${id}`),

  create: (row) => api.post("/test-sample-types", row),

  update: (id, row) => api.put(`/test-sample-types/${id}`, row),

  delete: (id) => api.delete(`/test-sample-types/${id}`),
};

export default testSampleTypeService;
